module.exports = __webpack_public_path__ + "static/media/ZylaandKaiJacket.6bc81f66.jpg";